import { Field, Formik, FormikProps } from 'formik';
import React, { useState } from 'react';
import { SimpleModal } from '../../components/simple-modal';
import { Util } from '../../lib/util';
import {
  ISignUpSchema,
  signUpInitialValues,
  signUpSchema,
} from './sign-up-schema';

export const SignUpComponent = () => {
  const [isThankYouOpen, setIsThankYouOpen] = useState<boolean>(false);
  return (
    <>
      {/* A little help for the Netlify bots :-( */}
      {/*
 // @ts-ignore */}
      <form name="sign-up" netlify="true" netlify-honeypot="bot-field" hidden>
        <input type="text" name="email" />
        <input name="name" />
        <input name="bot-field" type="hidden" />
        <p className="help is-danger is-active is-clipped " />{' '}
        {/* pulls into build */}
      </form>
      <SimpleModal
        modalOpen={isThankYouOpen}
        closeModal={() => setIsThankYouOpen(false)}
        title={'Thanks!'}
        closeButtonLabel="OK"
      >
        <div className="is-size-5 is-centered">Thank you for subscribing!</div>
      </SimpleModal>
      <Formik
        initialValues={signUpInitialValues}
        validationSchema={signUpSchema}
        onSubmit={(values, formikActions) => {
          console.log('submitting', values);
          fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: Util.encode({
              'form-name': 'sign-up',
              ...values,
            }),
          })
            .then(() => {
              setIsThankYouOpen(true);
            })
            .catch(error => alert(error));

          // e.preventDefault();

          formikActions.setSubmitting(false);
          formikActions.resetForm(signUpInitialValues);
        }}
        render={(props: FormikProps<ISignUpSchema>) => {
          const { isSubmitting, errors, submitCount } = props;
          return (
            <form
              name="sign-up"
              method="POST"
              data-netlify="true"
              onSubmit={props.handleSubmit}
            >
              <div className="is-size-4">Subscribe to our Newsletter</div>
              <Field type="hidden" name="bot-field" />
              <input type="hidden" name="form-name" value="sign-up" />
              <div className="field">
                <label className="label">Name</label>
                <div className="control">
                  <Field
                    type="input"
                    className="input"
                    placeholder="Name"
                    name="name"
                  />
                </div>
                <p
                  className={
                    'help is-danger' +
                    (errors.name && submitCount ? '' : ' is-hidden')
                  }
                >
                  {errors.name}
                </p>
              </div>
              <div className="field">
                <label className="label">Email</label>
                <div className="control has-icons-left">
                  <Field
                    className="input"
                    type="email"
                    placeholder="Enter your email address"
                    name="email"
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-envelope" />
                  </span>
                  {errors.email && submitCount ? (
                    <p className="help is-danger">{errors.email}</p>
                  ) : (
                    ''
                  )}
                </div>
              </div>

              <div className="control">
                <button
                  className="button is-link"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Sign Up
                </button>
              </div>
            </form>
          );
        }}
      />
    </>
  );
};
